import { render, staticRenderFns } from "./pdfReader.vue?vue&type=template&id=fadaed82&scoped=true&"
import script from "./pdfReader.vue?vue&type=script&lang=js&"
export * from "./pdfReader.vue?vue&type=script&lang=js&"
import style0 from "./pdfReader.vue?vue&type=style&index=0&id=fadaed82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadaed82",
  null
  
)

export default component.exports